var exports = {
  "kL": "xdbfd91f1--e05b80--container",
  "Qq": "xdbfd91f1--e05b80--text",
  "DD": "xdbfd91f1--e05b80--title",
  "VA": "xdbfd91f1--e05b80--subtitle",
  "Kk": "xdbfd91f1--e05b80--icon",
};

module.exports = exports;
